import Vue from 'vue';
import VueRouter from 'vue-router';
import { setupLayouts } from 'virtual:generated-layouts';
import generatedRoutes from 'virtual:generated-pages';
import NotFoundComponent from '../views/404.vue';

const routes = [{ path: '*', component: NotFoundComponent }];

generatedRoutes.forEach(v => {
  // console.log('v?.meta?.layout: ', v?.meta?.layout, setupLayouts([v])[0]);

  routes.push(v?.meta?.layout != false ? setupLayouts([v])[0] : v);
});
// console.log('routes: ', routes);

Vue.use(VueRouter);
const router = new VueRouter({
  mode: 'history',
  routes: routes,
});

/**解决路由点击报错 */
const originalPush = router.push;
router.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }

  return originalPush.call(this, location).catch(err => {
    if (VueRouter.isNavigationFailure(err)) {
      return err;
    }

    return Promise.reject(err);
  });
};

export function useRouter() {
  // const { proxy } = getCurrentInstance();
  return getCurrentInstance()?.proxy?.$router ?? router;
}

export function useRoute() {
  return getCurrentInstance()?.proxy?.$route ?? router.currentRoute;
}

// 主要解决不同角色登录，清楚上个角色的路由。由于vue-router 3.6 没有删除路由方法，故写个hack方法

export function resetRoleRouter() {
  // 获取原始路由数据
  const options = router.options;

  // 用原始数据重新 new 一个路由
  const _VueRouter = new VueRouter(options);

  // 用新路由的 matcher 替换旧路由的 matcher
  router.matcher = _VueRouter.matcher;
}

export default router;
